import React, { createContext, useContext, useState } from "react";

const FooterContext = createContext();

const severityRank = { info: 0, warning: 1, error: 2 };
const pickSeverity = (a, b) =>
  severityRank[b] > severityRank[a] ? b : a;

export function FooterProvider({ children }) {
  // message: { title, description, type }
  const [message, setMessage] = useState(null);

  const showMessage = (title, description = "", type = "info") => {
    setMessage(prev => {
      if (!prev) return { title, description, type };

      // Concatenate if already open
      const mergedTitle = prev.title
        ? `${prev.title} • ${title}`
        : title;

      const mergedDesc = [prev.description, description]
        .filter(Boolean)
        .join("\n");

      const mergedType = pickSeverity(prev.type ?? "info", type ?? "info");

      return { title: mergedTitle, description: mergedDesc, type: mergedType };
    });
  };

  const clearMessage = () => setMessage(null);

  return (
    <FooterContext.Provider value={{ message, showMessage, clearMessage }}>
      {children}
    </FooterContext.Provider>
  );
}

export function useFooter() {
  return useContext(FooterContext);
}
